import { Box, Typography } from "@mui/material";
import DocumentCard from "./DocumentCard";
import UploadArea from "./UploadArea";

/** Section title to API type: Investment Recommendations -> ir, Board Decks -> boarddeck */
function sectionTitleToType(title) {
 if (title === "Investment Recommendations") return "ir";
  if (title === "Board Decks") return "boarddeck";
  if (title === "Portfolio Company Updates") return "ir";  // ← ADD
  return null;
}

export default function DocumentSection({ section, documents, companyName, partnerCode, dealId, onAdd, onDelete, onProgress, onCancel, getFileContentUrl }) {
  const list = documents ?? section?.documents ?? [];
  const documentType = sectionTitleToType(section?.title);
  return (
    <Box
      sx={{
        border: "1px solid #e5e7eb",
        borderRadius: 2,
        p: 2,
        bgcolor: "#FAFAFA",
      }}
    >
      <Box display="flex" alignItems="center" justifyContent="space-between" gap={1} mb={2}>
        <Typography fontWeight={600}>{section.title}</Typography>
        <UploadArea
          documents={documents}
          companyName={companyName}
          partnerCode={partnerCode}
          dealId={dealId}
          documentType={documentType}
          onUploadSuccess={onAdd}
          onAdd={onAdd}
          onDelete={onDelete}
          onProgress={onProgress}
          onCancel={onCancel}
        />
      </Box>

      <Box display="flex" gap={2} flexWrap="wrap">
        {list.length === 0 && (
          <Typography color="text.secondary" fontSize={13}>
            No documents available.
          </Typography>
        )}
        {list.map((doc, index) => (
          <DocumentCard
            key={doc.path ?? doc.id ?? `${section.title}-${index}`}
            doc={doc}
            isVisible={true}
            onDelete={(doc) => onDelete(doc, documentType)}
            getFileContentUrl={getFileContentUrl}
          />
        ))}
      </Box>
    </Box>
  );
}
